import React, { useState, useEffect } from 'react';
import { Loader2, AlertCircle, Crown } from 'lucide-react';
import { useSubscription } from '../hooks/useSubscription';
import { PRODUCTS } from '../stripe-config';
import { useNavigate } from 'react-router-dom';

interface PremiumFeatureProps {
  feature: string;
  children: React.ReactNode;
  limitMessage?: string;
}

export function PremiumFeature({ feature, children, limitMessage }: PremiumFeatureProps) {
  const { 
    subscription,
    stripeSubscription,
    hasFeature, 
    loading, 
    error, 
    upgradeToPremium,
    canCreateSermon,
    canCreateAnalysis,
    getRemainingSermons,
    getRemainingAnalyses,
    isInTrial
  } = useSubscription();
  const navigate = useNavigate();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <Loader2 className="h-8 w-8 animate-spin text-electric" />
      </div>
    );
  }

  // Use the hasFeature function from subscription hook for consistent logic
  if (hasFeature(feature)) {
    return <>{children}</>;
  }

  // If trial expired and no active subscription, show upgrade prompt
  const handleUpgradeClick = () => {
    navigate('/dashboard/settings');
  };

  if (!hasFeature(feature)) {
    return (
      <div className="relative">
        <div className="opacity-50 pointer-events-none">
          {children}
        </div>

        
          <div className="absolute inset-0 bg-black/50 backdrop-blur-sm rounded-lg flex items-center justify-center">
            <div className="text-center text-white p-6">
              <Crown className="h-12 w-12 mx-auto mb-4 text-electric" />
              <h3 className="text-lg font-semibold mb-2">Premium Feature</h3>
              <p className="text-sm mb-4 opacity-90">
                Your trial has expired. Upgrade to SermonBuild Pro to continue accessing all premium features.
              </p>
              <button 
                onClick={handleUpgradeClick}
                className="bg-electric text-white px-4 py-2 rounded-lg hover:bg-electric/90 transition-colors flex items-center mx-auto"
              >
                Upgrade Now
              </button>
            </div>
          </div>
        
      </div>
    );
  }
}